import {
  getTableData,
  saveClaim,
  getClaimDetail,
  getEnTitle,
  getMatchingList,
  changeMatchingStatus,
  getMatchingDetail,
  saveMatching,
  delTranslation,
  addTranslation,
  editTranslation
} from '@/axios/api/claim'

const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_MATCHING_DETAIL = 'UPDATE_MATCHING_DETAIL'
const UPDATE_CLAIM_LIST = 'UPDATE_CLAIM_LIST'
const UPDATE_MATCHING_PAGER = 'UPDATE_MATCHING_PAGER'
const UPDATE_MATCHING_LIST = 'UPDATE_MATCHING_LIST'

const state = {
  tableData: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  detail: {},
  matchingDetail: {},
  claimList: [],
  matchingPager: {
    current: 1,
    size: 10,
    total: 0
  },
  matchingList: []
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      similarClaim: v.includeClaims && v.includeClaims.length
        ? v.includeClaims.map(value => value.title).join(',')
        : ''
    }
  }),
  pager: state => state.pager,
  detail: state => state.detail,
  claimList: state => state.claimList.map(v => {
    return {
      label: v.titleEn,
      value: v.id
    }
  }),
  matchingPager: state => state.matchingPager,
  matchingList: state => state.matchingList,
  matchingDetail: state => state.matchingDetail
}

const mutations = {
  [UPDATE_TABLE_DATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_CLAIM_LIST] (state, claimList) {
    state.claimList = claimList
  },
  [UPDATE_MATCHING_PAGER] (state, pager) {
    state.matchingPager = { ...state.matchingPager, ...pager }
  },
  [UPDATE_MATCHING_LIST] (state, matchingList) {
    state.matchingList = matchingList
  },
  [UPDATE_MATCHING_DETAIL] (state, matchingDetail) {
    state.matchingDetail = matchingDetail
  },
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    try {
      const { data: res } = await getTableData(params)
      commit(UPDATE_TABLE_DATA, res.records)
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {}
  },
  // 设置pager
  setPagerApi ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  // 新增 & 编辑
  async editClaimApi ({ commit }, params) {
    try {
      const res = await saveClaim(params)
      return res && res.data
    } catch (e) {
      return false
    }
  },
  async addTranslationApi ({ commit }, params) {
    try {
      const res = await addTranslation(params)
      return res && res.data
    } catch (e) {
      return false
    }
  },
  async editTranslationApi ({ commit }, params) {
    try {
      const res = await editTranslation(params)
      return res && res.data
    } catch (e) {
      return false
    }
  },
  // 详情
  async getDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getClaimDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
  },
  // 获取claim list
  async getClaimListApi ({ state, commit }, params) {
    try {
      const { data: res } = await getEnTitle(params)
      commit(UPDATE_CLAIM_LIST, res)
      return res || []
    } catch (e) {}
  },
  // 获取claim list
  async searchClaimListApi ({ state, commit }, params) {
    try {
      const { data: res } = await getEnTitle(params)
      return res || []
    } catch (e) {}
  },
  // 获取列表数据
  async getMatchingListApi ({ commit }, params) {
    try {
      const { data: res } = await getMatchingList(params)
      commit(UPDATE_MATCHING_LIST, res.records)
      commit(UPDATE_MATCHING_PAGER, { total: res.total })
    } catch (e) {}
  },
  // 设置pager
  setMatchingPagerApi ({ commit }, params) {
    commit(UPDATE_MATCHING_PAGER, params)
  },
  async changeMatchingStatusApi ({ commit }, params) {
    try {
      const res = await changeMatchingStatus(params)
      return res && res.errorCode === 200
    } catch (e) {}
  },
  // 详情
  async getMatchingDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getMatchingDetail(params)
      commit(UPDATE_MATCHING_DETAIL, res)
    } catch (e) {}
  },
  // 编辑
  async saveMatchingApi ({ commit }, params) {
    try {
      const res = await saveMatching(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  async delTranslationApi ({ commit }, params) {
    try {
      const res = await delTranslation(params)
      return res && res.errorCode === 200 && res.data !== false
    } catch (e) {}
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/claim.js